import type {
	FinancialStatementPeriodId,
	StatementMatrixViewModel,
} from "../../ui/FinancialDataGrid";

export const filterStatementViewModelPeriods = <TId extends FinancialStatementPeriodId>(
	viewModel: StatementMatrixViewModel<TId>,
	isSelected: (id: TId) => boolean,
): StatementMatrixViewModel<TId> => ({
	...viewModel,
	periods: viewModel.periods.filter((p) => isSelected(p.id)),
});
